import React from 'react';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import EmailField from './EmailField';
import FormRoleSelect from './FormRoleSelect';
import DebuggerAccessField from './DebuggerAccessField';

export default function UserFormFields() {
  const { eventDebuggerEcmEnabled } = useFeatureEnabled(FEATURE_FLAGS.eventDebuggerEcm);

  return (
    <>
      <EmailField />
      <FormRoleSelect />
      {eventDebuggerEcmEnabled && <DebuggerAccessField />}
    </>
  );
}
